import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';
import './auth.css';

/* Form card only — AuthPage owns the page layout, brand side, and the
   animated switch between this and the register form. */
export default function LoginForm({ authMessage, clearAuthMessage, onSwitch }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    clearAuthMessage();
    try {
      // Only authenticate here. App.js verifies admin role + company access
      // (lock / trial) and shows the reason via authMessage — keeping all
      // access checks in one place avoids racing sign-outs.
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      setError('Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  // App.js's rejection message (not an admin / locked / trial-expired) takes
  // precedence over a stale local error.
  const shownError = authMessage || error;

  const rise = (i) => ({ animationDelay: `${0.05 + i * 0.06}s` });

  return (
    <>
      <div className="auth-eyebrow auth-rise" style={rise(0)}>
        Admin dashboard
      </div>
      <h1 className="auth-title auth-rise" style={rise(1)}>
        Welcome <em>back.</em>
      </h1>
      <p className="auth-subtitle auth-rise" style={rise(2)}>
        Log in to see who&rsquo;s on shift right now.
      </p>

      {shownError && <div className="auth-error" role="alert">{shownError}</div>}

      <form onSubmit={handleLogin} noValidate>
        <div className="auth-field auth-rise" style={rise(3)}>
          <label className="auth-label" htmlFor="email">Email</label>
          <input
            id="email"
            className="auth-input"
            type="email"
            placeholder="jane@acmecorp.com"
            value={email}
            onChange={e => setEmail(e.target.value)}
            autoComplete="email"
            required
          />
        </div>
        <div className="auth-field auth-rise" style={rise(4)}>
          <label className="auth-label" htmlFor="password">Password</label>
          <div className="auth-input-wrap">
            <input
              id="password"
              className="auth-input has-toggle"
              type={showPassword ? 'text' : 'password'}
              placeholder="Your password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
            <button
              type="button"
              className="auth-toggle"
              onClick={() => setShowPassword(v => !v)}
              aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
              {showPassword ? 'Hide' : 'Show'}
            </button>
          </div>
        </div>

        <button className="auth-submit auth-rise" style={rise(5)} type="submit" disabled={loading}>
          {loading ? 'Signing in…' : 'Sign in'}
        </button>
      </form>

      <p className="auth-alt auth-rise" style={rise(6)}>
        New to OnShifts?{' '}
        <button type="button" className="auth-alt-link" onClick={onSwitch}>
          Start your free trial
        </button>
      </p>
    </>
  );
}
